export default "__VITE_ASSET__CqJeugr9__"